export default __webpack_public_path__ + "static/services_bg-b6051cc4736c08043426f65de871cef7.png";